import type React from 'react';
import { useMemo } from 'react';
import { shaderModels } from '../../../../types';
import { useProjectContext } from '../../ProjectContext';
import styles from './PreviewSection.module.css';

export const PreviewSection: React.FC = () => {
  const { selectedShader, shaderModel } = useProjectContext();

  // Memoize the shader component to prevent unnecessary re-renders
  const CurrentShader = useMemo(
    () => (selectedShader ? shaderModels[selectedShader] : null),
    [selectedShader]
  );

  if (!shaderModel || !selectedShader) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>
          <div className={styles.skeletonPreview}></div>
          <p>Loading shader preview...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.previewWrapper}>
        {CurrentShader && (
          <CurrentShader.Preview
            key={CurrentShader.name}
            // NOTE: Type assertion needed due to TypeScript limitation with union types
            // shaderModel is guaranteed to match selectedShader by ProjectContext
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            model={shaderModel as any}
          />
        )}
      </div>
    </div>
  );
};
